import { useState } from "react";
import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import Theme from '../../styles/Theme/Theme';
import { Text } from "../Global/Atomics/Text";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import CustomIcon from "../Global/Icons/CustomIcon";

export const SatisfactionWidget = () => {
    const { data, isLoading } = useFetch(query.path.satisfaction, 'getSatisfaction');
    const [isActive, setIsActive] = useState(0);
    if (!isLoading && isActive !== data?.value) {
        setIsActive(data?.value);
    }

    const emojies = [
        {
            icon: 'AwfulSmile',
            text: 'Awful',
            color: Theme.color['critical-base']
        },
        {
            icon: 'BadSmile',
            text: 'Bad',
            color: Theme.color['high-base']
        },
        {
            icon: 'OkSmile',
            text: 'Ok',
            color: Theme.color['medium-base']
        },
        {
            icon: 'GoodSmile',
            text: 'Good',
            color: Theme.color['low-base']
        },
        {
            icon: 'GreatSmile',
            text: 'Great',
            color: Theme.color['low-base']
        }
    ];

    return (
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} justifyContent='space-between'>
            <div style={{ display: "flex", alignItems: 'center', marginBottom: '16px' }}> {/*marginBottom {Theme.spacing.videowall.xxs} */}
                <CustomIcon icon={'Check'} iconSize='md' color={Theme.color['teal-4']} />
                <Text color={Theme.color['coolgray-12']} marginLeft={Theme.spacing.videowall.xs} fontSize='text_lg' fontWeight={Theme.typography.weight.medium}>Satisfaction</Text>
            </div>
            <div style={{ display: "flex", justifyContent: 'space-around', alignItems: 'self-end' }}>
                {emojies.map((val, key) => {
                    return (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} key={key}>
                        <CustomIcon color={isActive === key ? val.color : Theme.color['coolgray-6']} icon={val.icon} iconSize={isActive === key ? 'xl' : 'md'} marginBottom={Theme.spacing.videowall.xs} />
                        <Text color={isActive === key ? Theme.color['coolgray-12'] : Theme.color['coolgray-6']} marginTop={Theme.spacing.videowall.xs} fontSize='text_md' fontWeight={Theme.typography.weight.regular}>{val.text}</Text>
                    </div>)
                })}
            </div>
        </WidgetCard>
    )
};